import React, { Component } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  DatePicker,
  message,
  Upload,
  Popconfirm,
  Icon,
  Alert,
  Switch,
} from "antd";
import { columns, defaultData } from "./data";
import moment from "moment";
import request from "@/method/request";
import FileSaver from "file-saver";
import "./index.scss";

const { TextArea } = Input;

class index extends Component {
  state = {
    data: [],
    visible: false,
    actionData: {},
    loading: false,
    value: "",
    print: false,
  };

  componentDidMount() {
    this.getData();
  }

  onCancel = () => {
    this.setState({ actionData: {}, visible: false });
  };

  onShow = (item) => {
    this.setState({ visible: true, actionData: { ...defaultData, ...item } });
  };

  onChange = (name, v) => {
    this.setState({
      actionData: { ...this.state.actionData, [name]: v || "" },
    });
  };

  getData = async (value = "") => {
    try {
      const res = await request(`/contract/lst?value=${value}`);
      this.setState({
        data: [...res.data].map((x, i) => ({ ...x, index: i + 1 })),
      });
    } catch (error) {
      console.log(error);
    }
  };

  onSave = async () => {
    try {
      const data = this.state.actionData;
      const reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (data.email.some((x) => !reg.test(x)))
        return message.error("请输入正确的邮箱！");
      delete data.index;
      this.setState({ loading: true });
      let dataFrom = new FormData();
      if (!data.trial) data.trial = null;
      if (!data.end_time) data.end_time = null;
      if (!data.start_time) data.start_time = null;
      dataFrom.append(
        "data",
        JSON.stringify({ ...data, email: JSON.stringify(data.email || []) })
      );
      let headres = {
        method: "post",
        credentials: "include",
        headers: {},
        body: dataFrom,
      };
      const res = await request("/contract/save", headres);
      this.setState({ loading: false });
      if (res.status == 1) {
        message.success("保存成功！");
        this.setState({ actionData: {}, visible: false });
        this.getData();
      }
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
    }
  };

  render() {
    const { data, visible, actionData, loading, value, print } = this.state;

    const _columns = [...columns];
    if (!print)
      _columns.push({
        title: "操作",
        key: "action",
        render: (v, a, i) => {
          return (
            <div className="action-btn">
              {a.file && (
                <span
                  onClick={async () => {
                    window.open(a.file);
                  }}
                >
                  查看附件
                </span>
              )}
              <span
                onClick={() => {
                  this.onShow({ ...a, email: JSON.parse(a.email || "[]") });
                }}
              >
                编辑
              </span>
              <Popconfirm
                title={`确定要删除${a.hotel_name}合同吗?`}
                onConfirm={async () => {
                  try {
                    const res = await request(`/contract/delete?id=${a.id}`);
                    if (res.status != 1) message.error(res.msg);
                    else {
                      message.success("删除成功！");
                      this.setState({ data: data.filter((x) => x.id != a.id) });
                    }
                  } catch (error) {
                    console.log(error);
                  }
                }}
                okText="确定"
                cancelText="取消"
              >
                <span>删除</span>
              </Popconfirm>
            </div>
          );
        },
      });
    return (
      <div className="contract-management">
        <div className="title">合同管理</div>
        <div className="action">
          <div className="search">
            <Input
              placeholder="请输入关键词查询"
              value={value}
              onChange={(e) => this.setState({ value: e.target.value || "" })}
            />
            <Button type="primary" onClick={() => this.getData(value)}>
              搜索
            </Button>
          </div>
          <Button type="primary" onClick={() => this.onShow()}>
            新建合同
          </Button>
        </div>

        <Table
          columns={_columns}
          dataSource={data}
          rowKey={(r) => r.id}
          id="table"
          pagination={print ? false : undefined}
        />

        <Modal
          title={actionData.id ? "编辑合同" : "新建合同"}
          visible={visible}
          onOk={this.onSave}
          okText="保存"
          cancelText="取消"
          confirmLoading={loading}
          onCancel={this.onCancel}
          className="apply-billing"
        >
          <p>请填写合同接收信息</p>
          <p>
            <span className="billing-name">酒店名称:</span>
            <Input
              placeholder="请输入酒店名称"
              value={actionData.hotel_name}
              onChange={(e) => this.onChange("hotel_name", e.target.value)}
            />
          </p>
          <p>
            <span className="billing-name">姓名:</span>
            <Input
              placeholder="请输入联系人姓名"
              value={actionData.name}
              onChange={(e) => this.onChange("name", e.target.value)}
            />
          </p>
          <p>
            <span className="billing-name">职位:</span>
            <Input
              placeholder="请输入职位"
              value={actionData.position}
              onChange={(e) => this.onChange("position", e.target.value)}
            />
          </p>
          <p>
            <span className="billing-name">合同开始时间:</span>
            <DatePicker
              value={actionData.start_time && moment(actionData.start_time)}
              onChange={(date, str) => this.onChange("start_time", str)}
            />
          </p>
          <p>
            <span className="billing-name">合同截止时间:</span>
            <DatePicker
              value={actionData.end_time && moment(actionData.end_time)}
              onChange={(date, str) => this.onChange("end_time", str)}
            />
          </p>
          <p>
            <span className="billing-name">试用到期时间:</span>
            <DatePicker
              value={actionData.trial && moment(actionData.trial)}
              onChange={(date, str) => this.onChange("trial", str)}
            />
          </p>
          <p style={{ alignItems: "center" }}>
            <span className="billing-name">是否提醒:</span>
            <Switch
              style={{ marginLeft: 20 }}
              checkedChildren="开启提醒"
              unCheckedChildren="关闭提醒"
              value={actionData.is_remind}
              onChange={(v) => this.onChange("is_remind", v ? 1 : 0)}
            />
          </p>
          <p>
            <span className="billing-name">备注:</span>
            <TextArea
              placeholder="请输入备注"
              value={actionData.note}
              rows={3}
              onChange={(e) => this.onChange("note", e.target.value)}
            />
          </p>
          <p>
            <span className="billing-name">附件</span>
            <Upload
              action="/api/upload"
              disabled={loading}
              onChange={({ file }) => {
                if (file.status == "removed") {
                  this.setState({ actionData: { ...actionData, file: "" } });
                  return;
                }
                if (file.status == "uploading") {
                  this.setState({
                    loading: true,
                  });
                }
                if (file.status == "done")
                  this.setState({
                    actionData: {
                      ...actionData,
                      file: file.response.data || "",
                    },
                    loading: false,
                  });
                else
                  this.setState({
                    actionData: { ...actionData, file: file.uid },
                  });
              }}
              fileList={
                actionData.file
                  ? [
                      {
                        uid: actionData.file,
                        url: actionData.file,
                        name: actionData.file,
                      },
                    ]
                  : []
              }
            >
              <Button style={{ marginLeft: 20 }}>
                <Icon type="upload" /> {loading ? "上传数据中..." : "上传附件"}
              </Button>
            </Upload>
          </p>
          <p>
            <Alert message="默认通知创建者,可添加多个接收者" type="success" />
          </p>
          <p>
            <Button
              type="primary"
              block
              onClick={() => {
                let email = actionData.email;
                if (!email) email = [""];
                else email.push("");
                this.onChange("email", email);
              }}
            >
              增加接收邮箱
            </Button>
          </p>

          {(actionData.email || []).map((x, i) => {
            return (
              <p key={i} className="list-item">
                <span className="billing-name">邮件接收地址{i + 1}:</span>
                <Input
                  placeholder="请输入邮箱"
                  value={x}
                  onChange={(e) => {
                    let value = e.target.value || "";
                    let email = [...actionData.email];
                    email[i] = value;
                    this.onChange("email", email);
                  }}
                />
                <Icon
                  onClick={() => {
                    let email = [...actionData.email];
                    email.splice(i, 1);
                    this.onChange("email", email);
                  }}
                  type="delete"
                  className="del-icon"
                />
              </p>
            );
          })}
        </Modal>
        <div className="export-excel">
          <Button
            type="primary"
            onClick={() => {
              this.setState({ print: true }, () => {
                const innerHtml = ` 
                            ${document
                              .getElementById("table")
                              .innerHTML.replace(
                                /<table class="">/g,
                                '<table border="1">'
                              )}
                            `;

                var html =
                  "<html><head><meta charset='utf-8' /></head><body>" +
                  innerHtml +
                  "</body></html>";
                var blob = new Blob([html], {
                  type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, `合同管理.xls`);
                this.setState({ print: false });
              });
            }}
          >
            导出Excel
          </Button>
        </div>
      </div>
    );
  }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/contract/index.js